import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatabasetabComponent } from './databasetab.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ExpansionPanelModule } from "../../shared/components/expansion-panel/expansion-panel.module";
import { ChartModule } from 'angular-highcharts';
import { DatabasetabRoutingModule } from './database-routing.module';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';

@NgModule({
  declarations: [DatabasetabComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    MatSortModule,
    FormsModule,
    CustomDatePickerModule,
    CustomInputModule,
    CustomDropdownModule,
    ExpansionPanelModule,
    ChartModule,
    DatabasetabRoutingModule,
    PcMultiSelectFilterModule,
],
})
export class DatabasetabModule {}
